import { queryCache } from "~/components/common/ReactQueryClientProvider/ReactQueryClientProvider";
import { ErrorToast } from "~/components/common/Toast/Toast";

export async function importWithRetry(
  importFn: () => Promise<any>,
  retries = 5,
  interval = 1000
) {
  try {
    return await importFn();
  } catch (error) {
    if (retries) {
      await wait(interval);
      return importWithRetry(importFn, retries - 1, interval);
    } else {
      clearCacheAndRedirect();
    }
  }
}

function clearCache() {
  sessionStorage.clear();
  queryCache.clear();
}

function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function logoutOnTemporaryRedirect({
  response,
  message = "Update available. You'll be logged out in 5 seconds. Please start over. Sorry for the inconvenience",
  toastId = "appUpdate",
  skipToast = false,
}) {
  // 307 => temporary redirect [https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Status/307]
  if (response.status !== 307) return;

  if (!skipToast) {
    ErrorToast({
      message: message,
      toastId: toastId,
    });
  }

  setTimeout(() => clearCacheAndRedirect(), 5000);

  throw new Error(message);
}

function clearCacheAndRedirect() {
  clearCache();
  window.location.href = "/";
}
